import React, { useState } from 'react';

import { TmCreditCard, TmCreditCardSelectionType, TmCreditCardType } from '@/tscapi/model/account';

import { FormStandardCard } from './FormStandardCard';

interface CardTypeSelectorProps {
    selectedCreditCard?: TmCreditCard;
    selectedCardId?: number;
    selectedCardType?: string;
}

export const CardTypeSelector = ({ selectedCreditCard, selectedCardType }: CardTypeSelectorProps) => {
    const [creditCardErrorMessage, setCreditCardErrorMessage] = useState('');

    const dtest = () => {
        return TmCreditCardSelectionType.NonTSC;
    };
    const defaultValue = dtest();
    const paymentCardType = React.useState(defaultValue as string);

    return (
        <>
            <div>
                {creditCardErrorMessage && (
                    <div className="notification__red">
                        {/* <button
                            className="dialog__card__close-button"
                            type="button"
                            onClick={() => {
                                setCreditCardErrorMessage(null);
                            }}
                        >
                            <span className="visually-hidden">close</span>
                            <CloseSvg />
                        </button> */}
                        <img
                            src="/App_Assets/public/icon-exclamation-black.svg"
                            alt="exclamation-icon"
                            className="exclamation-img"
                        />
                        <div>
                            <strong>{creditCardErrorMessage}</strong>
                        </div>
                    </div>
                )}
                <div className="creditcard__required">Required fields are marked with an asterisk (*)</div>

                    <div className="creditcard__wrap">
                        <div className="card__logo--wrap">
                            <div className="card__logo--inline">
                                <img
                                    src="/App_Assets/public/visa.svg"
                                    width="24"
                                    height="24"
                                    alt="visa-icon"
                                    className="tagCCImageVisa"
                                ></img>
                            </div>
                            <div className="card__logo--inline">
                                <img
                                    src="/App_Assets/public/mastercard.svg"
                                    alt="mastercard-icon"
                                    width="30"
                                    height="30"
                                    style={{ maxWidth: '84px', width: '84px' }}
                                    className="tagCCImageMC"
                                ></img>
                            </div>
                            <div className="card__logo--inline">
                                <img
                                    src="/App_Assets/public/amex.svg"
                                    alt="amex-icon"
                                    width="24"
                                    height="24"
                                    className="tagCCImageAmex"
                                ></img>
                            </div>
                        </div>
                    </div>

                <div style={{ display: 'block' }} >
                    <FormStandardCard
                        setFormError={setCreditCardErrorMessage}
                        selectedCreditCard={
                            selectedCardType == 'VI' || selectedCardType == 'AX' || selectedCardType == 'MC'
                                ? selectedCreditCard
                                : null
                        }
                    />
                </div>
            </div>
        </>
    );
};
